
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class SpecSheetImportDialog extends Serenity.PropertyDialog<any, any>
    {
        protected getFormKey() { return SpecSheetImportForm.formKey; }
        protected useViewMode() { return true; }
        public issues: any[];
        public form = new SpecSheetImportForm(this.idPrefix);
        constructor() {
            super();

            this.form = new SpecSheetImportForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Excel Import";
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Import',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        SpecSheetService.ImportSpecSheet({
                            FileName: this.form.FileName.value.Filename
                        }, response => {
                            Q.notifyInfo(
                                'Inserted: ' + (response.Inserted || 0) +
                                ', Updated: ' + (response.Updated || 0));
                            this.issues = response.Issues;
                            if (response.ErrorList != null && response.ErrorList.length > 0) {
                                Q.notifyError(response.ErrorList.join(',\r\n '));
                            }

                            this.dialogClose();
                        }, { async: false });
                        //if (this.issues.length > 0) {
                        //    Q.postToService({
                        //        service: Common.ExcelImportService.baseUrl + '/IssuesExportExcel',
                        //        request: {
                        //            Issues: this.issues,
                        //        },

                        //        target: '_blank'
                        //    });
                        //}

                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}